export { default } from './ActivityFilterSlides'
